import { ReactNode } from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface IProps {
  children: ReactNode;
}

const Container = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: ${theme.colors.secondary600};
`;

const FieldHint = ({ children }: IProps) => <Container>{children}</Container>;

export default FieldHint;
